import { Contact } from "@/type/core/dashboard/dashboard.types";
import { FormInstance } from "antd";
import { FunctionComponent, useRef } from "react";
import { useTranslation } from "react-i18next";
import ContactForm, {
  ContactFormValues,
} from "@components/core/forms/ContactForm";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";

interface EditContactModalProps extends BasicModalProps {
  contact?: Contact;
  onConfirm: (contact?: Contact) => void;
}

const EditOrAddContactModal: FunctionComponent<EditContactModalProps> = ({
  contact,
  onConfirm,
  ...props
}) => {
  const { t } = useTranslation();
  const isEdit: boolean = contact !== undefined;

  const ref = useRef<FormInstance>(null);

  const handleSubmit = (formValue: ContactFormValues) => {
    const { email, firstname, lastname, phone, companyName, categories } =
      formValue;

    onConfirm({
      email,
      firstname,
      lastname,
      phone,
      companyName,
      category: categories.join("|"),
      officeId: "",
    });
    props.onCancel();
  };

  return (
    <BasicModal
      title={isEdit ? t("contacts.modifyContact") : t("contacts.addContact")}
      {...props}
      buttonText={
        isEdit
          ? t("contacts.editModal.confirm")
          : t("contacts.addModal.confirm")
      }
      showFooter={false}
      destroyOnClose
    >
      <ContactForm
        formRef={ref}
        showSubmitButton={true}
        defaultContact={contact}
        onSubmit={handleSubmit}
      />
    </BasicModal>
  );
};

export default EditOrAddContactModal;
